import { render, staticRenderFns } from "./JKPage.vue?vue&type=template&id=cf66bc86&scoped=true"
import script from "./JKPage.vue?vue&type=script&lang=js"
export * from "./JKPage.vue?vue&type=script&lang=js"
import style0 from "./JKPage.vue?vue&type=style&index=0&id=cf66bc86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf66bc86",
  null
  
)

export default component.exports